import { createFeatureSelector, createSelector } from '@ngrx/store';
import { KeyAppointmentReducer } from '../reducers';

export const selectKeyAppointmentFeature = createFeatureSelector<KeyAppointmentReducer.KeyAppointmentState>(KeyAppointmentReducer.featureName);

export const selectKeyAppointment = createSelector(selectKeyAppointmentFeature, (state: KeyAppointmentReducer.KeyAppointmentState) => state.item);
